import React from "react";
import { Link, useParams } from "react-router-dom";
import AppShell from "./AppShell";
import InfoCard from "./InfoCard";
import { getApp } from "../../../Constants/Apps";
import { useDocumentTitle } from "../../../Hooks/useDocumentTitle";

const AppDetail = () => {
  const { appId } = useParams();
  useDocumentTitle(getApp(appId)?.name);

  return (
    <AppShell>
      {({ app, content, t }) => (
        <>
          <section className="section app-section">
            <div className="container">
              <p className="app-description" data-reveal>{content.description}</p>
              <span className="eyebrow" data-reveal>{t.apps.features}</span>
              <div className="row app-features">
                {content.features.map((feature, index) => (
                  <InfoCard key={feature.title} item={feature} col="col-12 col-md-6 col-lg-3" style={{ "--d": index }} />
                ))}
              </div>
            </div>
          </section>

          <section className="section app-section">
            <div className="container">
              <div data-reveal>
                <span className="eyebrow">{t.apps.support}</span>
                <h2>{content.supportIntro}</h2>
              </div>
              <div className="row app-cards">
                {content.support.map((item, index) => (
                  <InfoCard key={item.title} item={item} writeUs={t.apps.writeUs} style={{ "--d": index % 3 }} />
                ))}
                <div className="col-12 col-md-6">
                  <Link to={`/apps/${app.id}/privacidad`} className="info-card info-card-privacy" data-reveal>
                    <div className="info-card-media" aria-hidden="true"><span>🔒</span></div>
                    <div className="info-card-body">
                      <h3>{t.apps.privacyTitle}</h3>
                      <p>{t.apps.privacyCta}</p>
                      <span className="info-card-cta">{t.apps.readPrivacy} →</span>
                    </div>
                  </Link>
                </div>
                {content.terms && (
                  <div className="col-12 col-md-6">
                    <Link to={`/apps/${app.id}/terminos`} className="info-card info-card-privacy" data-reveal>
                      <div className="info-card-media" aria-hidden="true"><span>📄</span></div>
                      <div className="info-card-body">
                        <h3>{t.apps.termsTitle}</h3>
                        <p>{t.apps.termsCta}</p>
                        <span className="info-card-cta">{t.apps.readTerms} →</span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </section>
        </>
      )}
    </AppShell>
  );
};

export default AppDetail;
